// extracted by mini-css-extract-plugin
export default {"editor":"StoryboardEditor_editor__e48p5","center":"StoryboardEditor_center__imUBe"};